/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ObservableRect.ts
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 1031
 * ---
 * Description:
 */

import Pamela from '@revodigital/pamela';
import {
  action,
  computed,
  makeObservable,
  observable
}             from 'mobx';
import {
  measureUnitToPixel
}             from '../../common/measure-unit-utils';
import {
  defaultSetterOptions,
  ObservableSetterOptions,
  ObservableShape
}             from './ObservableShape';

export class ObservableRect extends ObservableShape<Pamela.Rect> {
  @observable
  private _cornerRadius?: number | number[];

  constructor(shape: Pamela.Rect, editor: any) {
    super(shape, editor);
    this._cornerRadius = shape.cornerRadius();
    makeObservable(this);
  }

  @action
  public setCornerRadius(value: number | number[], options: ObservableSetterOptions = defaultSetterOptions) {
    this._cornerRadius = value;
    if (options.applyToPamelaShape)
      (this.pamelaShape__nonObservable as unknown as Pamela.Rect).cornerRadius(
        measureUnitToPixel(this.editor.projectData.projectOptions.measureUnit,
          value as number));

    this.editor.history.takeSnapshot();
  }

  @computed
  public get cornerRadius(): number | number[] | undefined {
    return this._cornerRadius;
  }
}